import { Badge } from "V2.0/common/badge";
import { Button } from "V2.0/common/button";

import { PencilIcon, XMarkIcon, PlusIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import SlotTagInput from "./SlotTagInput";

// A fixed, visually distinct palette so the same tag text always renders the
// same color — makes it possible to pattern-match tags across days at a
// glance instead of every tag looking identical.
const TAG_COLORS = ["blue", "emerald", "violet", "rose", "amber", "cyan", "fuchsia", "lime"];

function getTagColor(tag) {
  if (!tag) return "blue";
  let hash = 0;
  for (let i = 0; i < tag.length; i++) {
    hash = (hash * 31 + tag.charCodeAt(i)) % TAG_COLORS.length;
  }
  return TAG_COLORS[Math.abs(hash) % TAG_COLORS.length];
}

export default function SlotTag(props) {
  const { slot, onSlotTagUpdate, availableSlotTags } = props;

  const [openSlotTagInput, setOpenSlotTagInput] = useState(false);

  const handleSlotTagInputClose = () => setOpenSlotTagInput(false);
  const handleSlotTagInputOpen = () => setOpenSlotTagInput(true);

  const removeSlotTag = () => {
    onSlotTagUpdate({
      ...slot,
      slotTag: "",
    });
  };

  const handleSlotTagUpdate = (slotTag) => {
    onSlotTagUpdate({
      ...slot,
      slotTag,
    });
  };

  return (
    <>
      {slot?.slotTag ? (
        <div className="flex gap-x-1.5 items-center">
          <Badge color={getTagColor(slot.slotTag)}>{slot.slotTag}</Badge>
          <div className="flex items-center gap-x-1 invisible group-hover:visible">
            <PencilIcon
              onClick={handleSlotTagInputOpen}
              className="hover:cursor-pointer hover:text-amber-500 size-3.5 text-gray-400"
            />
            <XMarkIcon
              onClick={removeSlotTag}
              className="hover:cursor-pointer hover:text-red-500 size-3.5 text-gray-400"
            />
          </div>
        </div>
      ) : (
        <div className="invisible group-hover:visible">
          <Button plain onClick={handleSlotTagInputOpen}>
            <PlusIcon /> tag
          </Button>
        </div>
      )}
      {openSlotTagInput && (
        <SlotTagInput
          slotTag={slot?.slotTag || ""}
          onClose={handleSlotTagInputClose}
          availableSlotTags={availableSlotTags}
          onSlotTagUpdate={handleSlotTagUpdate}
        />
      )}
    </>
  );
}